var a = Object.defineProperty, f = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var p = (o, e, m) => e in o ? a(o, e, { enumerable: !0, configurable: !0, writable: !0, value: m }) : o[e] = m, t = (o, e) => {
  for (var m in e || (e = {}))
    l.call(e, m) && p(o, m, e[m]);
  if (r)
    for (var m of r(e))
      s.call(e, m) && p(o, m, e[m]);
  return o;
}, i = (o, e) => f(o, c(e));
import n, { forwardRef as y } from "react";
import d from "../lib/IconBase.mjs";
import w from "../defs/CopySimple.mjs";
const C = y((o, e) => /* @__PURE__ */ n.createElement(d, i(t({ ref: e }, o), { weights: w })));
C.displayName = "CopySimple";
export {
  C as CopySimple
};
